import axios from 'axios';

const httpClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 20000,
});

httpClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const isFormData = config.data instanceof FormData;
  if (!isFormData) {
    config.headers['Content-Type'] = 'application/json';
  }
  config.headers['x-api-key'] = process.env.REACT_APP_API_KEY;
  config.headers['x-computer-name'] = navigator.platform;
  const sessionId = sessionStorage.getItem('edenTrackingSessionId');
  if (sessionId) config.headers['x-session-id'] = sessionId;
  config.headers['x-current-path'] =
    window.location.pathname + window.location.search + window.location.hash;
  return config;
});

httpClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Don't process abort errors - let them pass through
    if (
      error.name === 'AbortError' ||
      error.name === 'CanceledError' ||
      error.code === 'ERR_CANCELED'
    ) {
      return Promise.reject(error);
    }
    if (error.response?.status === 401 || error.response?.status === 403) {
      localStorage.removeItem('token');
    }
    return Promise.reject(error);
  },
);

export default httpClient;
